import { render, staticRenderFns } from "./DetailExamination.vue?vue&type=template&id=d7849f30&"
import script from "./DetailExamination.vue?vue&type=script&lang=js&"
export * from "./DetailExamination.vue?vue&type=script&lang=js&"
import style0 from "./DetailExamination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports